import { EnvConfig } from '../types';

const productionConfig: EnvConfig = {
  // SENTRY
  SENTRY_ENV: 'production',
  SENTRY_DSN: 'https://a1c191a390da447697f76fc7547b1bb4@sentry.io/1417052',

  // GTM
  GTM_ENABLED: true,

  // CLICK HOUSE
  CLICK_HOUSE_ENABLED: true,

  // API
  API_URL: 'https://apis.reas.cz',

  DISABLED_FEATURES: {},
};

export default productionConfig;
